import React from "react";

function RecurringScheduleTable({

    rows = [],

    onView,

    onEdit,

    onPause,

    onResume,

    onCancel

}) {

    return (

        <div className="table-responsive">

            <table className="table table-bordered table-hover">

                <thead className="table-light">

                    <tr>

                        <th style={{ width: 60 }}>
                            #
                        </th>

                        <th>
                            Schedule Name
                        </th>

                        <th>
                            Work Mode
                        </th>

                        <th>
                            Frequency
                        </th>

                        <th>
                            Execution Time
                        </th>

                        <th>
                            Next Run
                        </th>

                        <th>
                            Last Run
                        </th>

                        <th>
                            Status
                        </th>

                        <th>
                            Priority
                        </th>

                        <th style={{ width: 220 }}>
                            Actions
                        </th>

                    </tr>

                </thead>

                <tbody>

                    {rows.length === 0 && (

                        <tr>

                            <td
                                colSpan={10}
                                className="text-center"
                            >

                                No schedules found.

                            </td>

                        </tr>

                    )}

                    {rows.map((row, index) => (

                        <tr key={row.id}>

                            <td>

                                {index + 1}

                            </td>

                            <td>

                                {row.schedule_name}

                            </td>

                            <td>

                                {row.work_mode}

                            </td>

                            <td>

                                {row.frequency}

                            </td>

                            <td>

                                {row.execution_time || "-"}

                            </td>

                            <td>

                                {row.next_run_date || "-"}

                            </td>

                            <td>

                                {row.last_run_date || "-"}

                            </td>

                            <td>

                                <span
                                    className={`badge ${
                                        row.status === "ACTIVE"
                                            ? "bg-success"
                                            : row.status === "PAUSED"
                                            ? "bg-warning text-dark"
                                            : "bg-danger"
                                    }`}
                                >

                                    {row.status}

                                </span>

                            </td>

                            <td>

                                <span
                                    className="badge bg-secondary"
                                >

                                    {row.priority}

                                </span>

                            </td>

                            <td>

                                <div
                                    className="btn-group btn-group-sm"
                                    role="group"
                                >

                                    <button
                                        type="button"
                                        className="btn btn-outline-info"
                                        title="View"
                                        onClick={() => onView?.(row)}
                                    >

                                        <i className="fas fa-eye" />

                                    </button>

                                    <button
                                        type="button"
                                        className="btn btn-outline-primary"
                                        title="Edit"
                                        onClick={() => onEdit?.(row)}
                                    >

                                        <i className="fas fa-edit" />

                                    </button>

                                    {row.status === "ACTIVE" && (

                                        <button
                                            type="button"
                                            className="btn btn-outline-warning"
                                            title="Pause"
                                            onClick={() => onPause?.(row)}
                                        >

                                            <i className="fas fa-pause" />

                                        </button>

                                    )}

                                    {row.status === "PAUSED" && (

                                        <button
                                            type="button"
                                            className="btn btn-outline-success"
                                            title="Resume"
                                            onClick={() => onResume?.(row)}
                                        >

                                            <i className="fas fa-play" />

                                        </button>

                                    )}

                                    {row.status !== "CANCELLED" && (

                                        <button
                                            type="button"
                                            className="btn btn-outline-danger"
                                            title="Cancel"
                                            onClick={() => onCancel?.(row)}
                                        >

                                            <i className="fas fa-times" />

                                        </button>

                                    )}

                                </div>

                            </td>

                        </tr>

                    ))}

                </tbody>

            </table>

        </div>

    );

}

export default RecurringScheduleTable;